export default "__VITE_ASSET__525d819d__"